import React from 'react';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';
import { saveStates } from '@/constants/lifecycle';
import CloseButton from '@/components/buttons/CloseButton';
import { resolveCatalogueTemplate } from '../catalogue/helper';
import { datasetDirtyFlags, datasetIsDirty, datasetSourceAndStepAttributes } from '../state/state';
import { destroyDataset, updateDatasetCancel } from '../actions';
import datasetDiff from '../helper';
import { disableDatasetWizardCancel } from '../status/helper';

const DatasetWizardCancelButton = ({
  cancelDataset,
  cancelUpdate,
  category,
  closeMessageId,
  code,
  dataset,
  disabled,
  isDirty,
  isNew,
  sourceUrl,
}) => {
  const intl = useIntl();
  const onCloseClick = () => {
    if (isNew) {
      cancelDataset([{ code, isNew: true, steps: { sourceUrl } }], true);
    } else {
      const updates = datasetDiff(dataset);
      const cancel = !isDirty
          || !updates
          || window.confirm(intl.formatMessage({ id: 'dataset.edit.cancel.warning' }));

      if (cancel) {
        cancelUpdate(category, code);
      }
    }
  };

  return (<CloseButton onClick={onCloseClick} disabled={disabled} messageId={closeMessageId} />);
};

export const mapStateToProps = ({
  catalogues: { templates },
  datasets: { datasets },
}, ownProps) => {
  const { dataset, template } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    isNew: false,
    isDirty: datasetDirtyFlags(),
    steps: datasetSourceAndStepAttributes(),
    ...saveStates,
  });

  return ({
    dataset,
    disabled: dataset.isNew ? false : disableDatasetWizardCancel(dataset, template),
    isDirty: datasetIsDirty(dataset),
    isNew: dataset.isNew,
    sourceUrl: dataset.steps.sourceUrl,
  });
};

export const mapDispatchToProps = {
  cancelUpdate: updateDatasetCancel,
  cancelDataset: destroyDataset,
};

export default connect(mapStateToProps, mapDispatchToProps)(DatasetWizardCancelButton);
